import { ReactNode, useState } from "react";

interface PassVisualContainerProps {
  leftPass: ReactNode;
  rightPass: ReactNode;
  groupHoverClass: string; // e.g., 'group-hover/coupon' or 'group-hover/loyalty'
}

type HoveredCard = 'apple' | 'google' | null;

export const PassVisualContainer = ({
  leftPass,
  rightPass,
  groupHoverClass
}: PassVisualContainerProps) => {
  const [hoveredCard, setHoveredCard] = useState<HoveredCard>(null);

  // Calculate transform and scale based on hover state
  const getAppleTransform = () => {
    if (hoveredCard === 'apple') {
      return 'rotate(0deg) scale(1.15)';
    } else if (hoveredCard === 'google') {
      return 'rotate(-6deg) scale(0.95)';
    }
    return 'rotate(-6deg) scale(1)';
  };

  const getGoogleTransform = () => {
    if (hoveredCard === 'google') {
      return 'rotate(0deg) scale(1.15)';
    } else if (hoveredCard === 'apple') {
      return 'rotate(6deg) scale(0.95)';
    }
    return 'rotate(6deg) scale(1)';
  };

  const getAppleZIndex = () => {
    if (hoveredCard === 'apple') return 50;
    if (hoveredCard === 'google') return 0;
    return 10;
  };

  const getGoogleZIndex = () => {
    if (hoveredCard === 'google') return 50;
    if (hoveredCard === 'apple') return 0;
    return 5;
  };

  const getGoogleOpacity = () => {
    if (hoveredCard === 'google') return 1;
    return 0.7;
  };

  return (
    <div className="relative w-full h-full min-h-[240px] flex items-center justify-center">
      <div className="flex items-center">
        {/* Apple Wallet Pass */}
        <div
          className="relative animate-bento-float transition-all duration-700 ease-in-out cursor-pointer group-hover/coupon:rotate-0 group-hover/coupon:-translate-x-6 group-hover/loyalty:rotate-0 group-hover/loyalty:-translate-x-6"
          style={{
            transform: getAppleTransform(),
            zIndex: getAppleZIndex(),
          }}
          onMouseEnter={() => setHoveredCard('apple')}
          onMouseLeave={() => setHoveredCard(null)}
        >
          {/* Apple Wallet label */}
          <div
            className="absolute -top-8 left-1/2 -translate-x-1/2 transition-opacity duration-500 group-hover/coupon:opacity-100 group-hover/loyalty:opacity-100"
            style={{ opacity: hoveredCard === 'apple' ? 1 : 0 }}
          >
            <span className="text-xs font-medium text-foreground/70 whitespace-nowrap">Apple Wallet</span>
          </div>
          {leftPass}
        </div>

        {/* Google Wallet Pass */}
        <div
          className="relative animate-bento-float-delayed transition-all duration-700 ease-in-out cursor-pointer -ml-20 group-hover/coupon:ml-0 group-hover/coupon:translate-x-6 group-hover/coupon:rotate-0 group-hover/loyalty:ml-0 group-hover/loyalty:translate-x-6 group-hover/loyalty:rotate-0 group-hover/coupon:opacity-100 group-hover/loyalty:opacity-100"
          style={{
            transform: getGoogleTransform(),
            zIndex: getGoogleZIndex(),
            opacity: getGoogleOpacity(),
          }}
          onMouseEnter={() => setHoveredCard('google')}
          onMouseLeave={() => setHoveredCard(null)}
        >
          {/* Google Wallet label */}
          <div
            className="absolute -top-8 left-1/2 -translate-x-1/2 transition-opacity duration-500 group-hover/coupon:opacity-100 group-hover/loyalty:opacity-100"
            style={{ opacity: hoveredCard === 'google' ? 1 : 0 }}
          >
            <span className="text-xs font-medium text-foreground/70 whitespace-nowrap">Google Wallet</span>
          </div>
          {rightPass}
        </div>
      </div>
    </div>
  );
};
